// Shared localStorage keys used by all HGS state hooks
export const STORAGE_KEYS = {
  user: 'hgs_user',
  masters: 'hgs_masters',
  meta: 'hgs_master_meta',
  history: 'hgs_version_history',
  pendingApprovals: 'hgs_pending_master_approvals',
  responses: 'hgs_form_responses',
  riskUniverse: 'hgs_risk_universe',
  countermeasures: 'hgs_countermeasures',
  trainingOk: 'hgs_training_ok',
  notifications: 'hgs_notifications',
  riskPublished: 'hgs_risk_published',
  riskApplicability: 'hgs_risk_applicability',
  riskEvaluations: 'hgs_risk_evaluations',
  versionSnapshots: 'hgs_version_snapshots',
};
